import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import glitch from "../img/glitch.mp4";
import Intro from "../components/Intro";

const Home = () => {
  return (
    <HomePage id="/">
      <div className="gradient bg-overlay"></div>
      <div className="gradient gradient-2 bg-overlay"></div>
      <div className="screen-overlay bg-overlay"></div>
      <video autoPlay muted loop className="bg-overlay">
        <source src={glitch} type="video/mp4" />
      </video>
      <Intro />
    </HomePage>
  );
};

export default Home;

const HomePage = styled(motion.div)`
  position: relative;

  .gradient {
    background-image: linear-gradient(transparent, #0c0c0c);
    opacity: 0.8;
    position: absolute;
    height: 100%;
  }

  .gradient-2 {
    opacity: 1;
    position: absolute;
  }

  .screen-overlay {
    background: #0c0c0c;
    opacity: 0.9;
    z-index: -9;
  }

  video {
    z-index: -10;
  }
`;
